var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnimateNumber',{ref:"myNum",attrs:{"startVal":_vm.fromNum,"endVal":_vm.toNum,"duration":500,"decimals":2,"separator":"","useEasing":false}})}
var staticRenderFns = []

export { render, staticRenderFns }